import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../lib/api';
import { AUTH_ENABLED } from '../lib/auth';
import type { Offer } from '../lib/types';

const noopGetToken = async () => null;

export function useProfileOffers(
  profileId: string | null | undefined,
  getToken: () => Promise<string | null> = noopGetToken
) {
  const [offers, setOffers] = useState<Offer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOffers = useCallback(async () => {
    if (!AUTH_ENABLED || !profileId) { setLoading(false); return; }
    try {
      setLoading(true);
      const data = await apiFetch<Offer[]>(`/profiles/${profileId}/offers`, {}, getToken);
      setOffers(data);
      setError(null);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [profileId, getToken]);

  useEffect(() => { fetchOffers(); }, [fetchOffers]);

  return { offers, loading, error, refetch: fetchOffers };
}
